import { CensusFileRowRawDataDto } from '../api/dto/census-file-row.dto'
import {
  CensusFileRowGridData,
  CensusFileRowDisplayField,
} from '../types/census-file-row-grid-data'
import { ColDef } from '@ag-grid-community/core'

// These are your known required fields — ideally exported from one place
// required = true means the field is required to be in the grid
// sortOrder number is the order of the field in the grid
const DISPLAY_FIELDS: CensusFileRowDisplayField[] = [
  { field: 'FirstName', required: true, sortOrder: 1 },
  { field: 'LastName', required: true, sortOrder: 2 },
  { field: 'CompanyEmployeeId', required: true, sortOrder: 3 },
  { field: 'HireDate', required: true, sortOrder: 4 },
  { field: 'ReHireDate', required: false, sortOrder: 5 },
  { field: 'EnrollmentStartDate', required: false, sortOrder: 6 },
  { field: 'EnrollmentEndDate', required: false, sortOrder: 7 },
  { field: 'DateOfBirth', required: true, sortOrder: 8 },
  { field: 'Gender', required: true, sortOrder: 9 },
  { field: 'Relationship', required: true, sortOrder: 10 },
  { field: 'MarriageStatus', required: true, sortOrder: 11 },
  { field: 'Smoker', required: true, sortOrder: 12 },
  { field: 'SSN', required: true, sortOrder: 13 },
  { field: 'EmailAddress', required: true, sortOrder: 14 },
  { field: 'EmailAddressType', required: false, sortOrder: 15 },
  { field: 'PhoneNumber', required: true, sortOrder: 16 },
  { field: 'PhoneType', required: true, sortOrder: 17 },
  { field: 'StreetAddress', required: true, sortOrder: 18 },
  { field: 'StreetAddressExt', required: false, sortOrder: 19 },
  { field: 'City', required: true, sortOrder: 18 },
  { field: 'PostalCode', required: true, sortOrder: 19 },
  { field: 'StateProvince', required: true, sortOrder: 20 },
  { field: 'County', required: false, sortOrder: 21 },
  { field: 'MailingStreetAddress', required: false, sortOrder: 22 },
  { field: 'MailingStreetAddressExt', required: false, sortOrder: 23 },
  { field: 'MailingCity', required: false, sortOrder: 24 },
  { field: 'MailingPostalCode', required: false, sortOrder: 25 },
  { field: 'MailingStateProvince', required: false, sortOrder: 26 },
  { field: 'EmploymentType', required: false, sortOrder: 27 },
  { field: 'EmploymentStatus', required: true, sortOrder: 28 },
  { field: 'IsExempt', required: true, sortOrder: 28 },
  { field: 'Salary', required: true, sortOrder: 29 },
  { field: 'HourlyWage', required: false, sortOrder: 30 },
  { field: 'PayrollCycle', required: true, sortOrder: 31 },
  { field: 'JobTitle', required: false, sortOrder: 31 },
  { field: 'CompanyCode', required: false, sortOrder: 32 },
  { field: 'DivisionCode', required: false, sortOrder: 33 },
  { field: 'DepartmentCode', required: false, sortOrder: 34 },
  { field: 'Department', required: false, sortOrder: 35 },
  { field: 'ContributionGroup', required: false, sortOrder: 36 },
  { field: 'Eligibility_1', required: false, sortOrder: 37 },
  { field: 'Eligibility_2', required: false, sortOrder: 38 },
  { field: 'Eligibility_3', required: false, sortOrder: 39 },
  { field: 'Eligibility_4', required: false, sortOrder: 40 },
  { field: 'CompanyID', required: false, sortOrder: 41 },
]

export const colDefsFromData = (
  firstRow: CensusFileRowRawDataDto
): ColDef<CensusFileRowGridData>[] => {
  const colBlacklist = ['clientPublicKey', 'id']
  if (!firstRow) return []

  // Get all keys from the data except blacklisted ones
  const dataKeys = Object.keys(firstRow).filter(
    (key) => !colBlacklist.includes(key)
  )

  // Get all required fields
  const requiredFields = DISPLAY_FIELDS.filter((field) => field.required).map(
    (field) => field.field
  )
  // Add any missing required fields
  const allKeys = Array.from(
    new Set([...requiredFields, ...dataKeys]) // Set removes duplicates
  )

  // Sort the keys by sortOrder
  allKeys.sort((a, b) => {
    const aOrder =
      DISPLAY_FIELDS.find((field) => field.field === a)?.sortOrder ?? 999
    const bOrder =
      DISPLAY_FIELDS.find((field) => field.field === b)?.sortOrder ?? 999
    return aOrder - bOrder
  })

  return allKeys.map((key) => ({
    field: key,
    sortable: true,
    resizable: true,
    sortPrefix: 'rowData:',
  }))
}
